// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Rtl from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignInAdmin from "layouts/authentication/sign-in-admin";
import SignUp from "layouts/authentication/sign-up";
import Trading from "layouts/docs/trading";
import TradingTwoThree from "layouts/docs/trading-two-three";
import TradingTwoFour from "layouts/docs/trading-two-four";
import TradingTwoFive from "layouts/docs/trading-two-five";
import TradingTwoFiveOne from "layouts/docs/trading-two-five-one";
import TradingTwoFiveThree from "layouts/docs/trading-two-five-three";
import Fix from "layouts/docs/fix";
import JournalAPI from "layouts/docs/journal";
import FixThreeFive from "layouts/docs/fix-three-five";
// @mui icons
import Icon from "@mui/material/Icon";
import HomePage from "layouts/landing/home";
import Products from "layouts/products";
import RegisterSuccess from "layouts/authentication/sign-up-success";
import ForgetPassword from "layouts/authentication/forget-password";
import GetProductionAccess from "layouts/get-production-access";
import ResetPassword from "layouts/authentication/reset-password";
import NDASuccess from "layouts/authentication/nda-success";
import AccountOpening from "layouts/docs/account-opening";
import Funding from "layouts/docs/funding";
import AccountOpeningIcon from "./assets/images/account-opening.svg";
import FundsApprovalIcon from "./assets/images/funds-approval.svg";
import FixIcon from "./assets/images/fix.svg";
import OMSIcon from "./assets/images/oms.svg";
import Users from "layouts/users";
import TechUsers from "layouts/users/tech_user";
import Support from "layouts/support";
import SupportRM from "layouts/rmsupport";
import ProductionRequest from "layouts/production-request";
import AuditTrail from "layouts/audit-trail";

const items = [
  {
    id: 1,
    type: "collapse",
    name: "Account Opening API",
    key: "account-opening-api",
    icon: (
      <img
        src={AccountOpeningIcon}
        style={{ height: "1rem", width: "1rem" }}
        alt="Account Opening API"
      />
    ),
    route: "/products/account-opening-api",
    component: <AccountOpening />,
    showInSidebar: true,
  },
  {
    id: 2,
    type: "collapse",
    name: "Funding API",
    key: "funding-api",
    icon: (
      <img
        src={FundsApprovalIcon}
        style={{ height: "1rem", width: "1rem" }}
        alt="Funding API"
      />
    ),
    route: "/products/funding-api",
    component: <Funding />,
    showInSidebar: true,
  },
  {
    id: 3,
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: (
      <img
        src={OMSIcon}
        style={{ height: "1rem", width: "1rem" }}
        alt="Trading API"
      />
    ),
    route: "/products/trading-api-v2.5.3",
    component: <TradingTwoFiveThree />,
    showInSidebar: true,
  },
  {
    id: 4,
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: (
      <img
        src={FixIcon}
        style={{ height: "1rem", width: "1rem" }}
        alt="Trading API"
      />
    ),
    route: "/products/fix-specifications-v3.5",
    component: <FixThreeFive />,
    showInSidebar: true,
  },
  {
    id: 5,
    type: "collapse",
    name: "Journal API",
    key: "journal-api",
    icon: (
      <img
        src={FixIcon}
        style={{ height: "1rem", width: "1rem" }}
        alt="Journal API"
      />
    ),
    route: "/products/journal-api",
    component: <JournalAPI />,
    showInSidebar: true,
  },
];
// Customer Routes
export const customerRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/products",
    component: <Products />,
    showInSidebar: true,
    dropdown: true,
    dropdownItems: items,
  },
  {
    type: "collapse",
    name: "Account Opening API",
    key: "account-opening-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/account-opening-api",
    component: <AccountOpening />,
  },
  {
    type: "collapse",
    name: "Funding API",
    key: "funding-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/funding-api",
    component: <Funding />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.3",
    component: <TradingTwoFiveThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.1",
    component: <TradingTwoFiveOne />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5",
    component: <TradingTwoFive />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.4",
    component: <TradingTwoFour />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.3",
    component: <TradingTwoThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.2.4",
    component: <Trading />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.5",
    component: <FixThreeFive />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.2",
    component: <Fix />,
  },
  {
    type: "collapse",
    name: "Journal API",
    key: "journal-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/journal-api",
    component: <JournalAPI />,
  },
  {
    type: "collapse",
    name: "Get Production Access",
    key: "get-production-access",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/get-production-access",
    component: <GetProductionAccess />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Tables",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: <Billing />,
  },
  {
    type: "collapse",
    name: "RTL",
    key: "rtl",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/rtl",
    component: <Rtl />,
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    type: "collapse",
    name: "Support",
    key: "support",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/support",
    component: <Support />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "Success",
    key: "success",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up/success",
    component: <RegisterSuccess />,
  },
  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <HomePage />,
  },
];

// RM Routes
export const rmRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <Users />,
    showInSidebar: true,
  },

  // {
  //   type: "collapse",
  //   name: "Sandbox Requests",
  //   key: "sandbox-requests",
  //   icon: <Icon fontSize="small">add_chart</Icon>,
  //   route: "/sandbox-requests",
  //   component: <AccessRequests />,
  //   showInSidebar: true,
  // },

  {
    type: "collapse",
    name: "Production Requests",
    key: "production-requests",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/production-requests",
    component: <ProductionRequest />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Support",
    key: "support",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/support",
    component: <SupportRM />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/products",
    component: <Products />,
    showInSidebar: true,
    dropdown: true,
    dropdownItems: items,
  },

  {
    type: "collapse",
    name: "Account Opening API",
    key: "account-opening-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/account-opening-api",
    component: <AccountOpening />,
  },
  {
    type: "collapse",
    name: "Funding API",
    key: "funding-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/funding-api",
    component: <Funding />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.3",
    component: <TradingTwoFiveThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.1",
    component: <TradingTwoFiveOne />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5",
    component: <TradingTwoFive />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.4",
    component: <TradingTwoFour />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.3",
    component: <TradingTwoThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.2.4",
    component: <Trading />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.5",
    component: <FixThreeFive />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.2",
    component: <Fix />,
  },
  {
    type: "collapse",
    name: "Journal API",
    key: "journal-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/journal-api",
    component: <JournalAPI />,
  },
  {
    type: "collapse",
    name: "Audit Trail",
    key: "audit-trail",
    icon: <Icon fontSize="small">find_in_page</Icon>,
    route: "/audit-trail",
    component: <AuditTrail />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    showInSidebar: true,
  },

  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <HomePage />,
  },
];

// Support Routes
export const supportRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Support",
    key: "support",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/support",
    component: <SupportRM />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/products",
    component: <Products />,
    showInSidebar: true,
    dropdown: true,
    dropdownItems: items,
  },

  {
    type: "collapse",
    name: "Account Opening API",
    key: "account-opening-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/account-opening-api",
    component: <AccountOpening />,
  },
  {
    type: "collapse",
    name: "Funding API",
    key: "funding-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/funding-api",
    component: <Funding />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.3",
    component: <TradingTwoFiveThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.1",
    component: <TradingTwoFiveOne />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5",
    component: <TradingTwoFive />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.4",
    component: <TradingTwoFour />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.3",
    component: <TradingTwoThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.2.4",
    component: <Trading />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.5",
    component: <FixThreeFive />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.2",
    component: <Fix />,
  },
  {
    type: "collapse",
    name: "Journal API",
    key: "journal-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/journal-api",
    component: <JournalAPI />,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    showInSidebar: true,
  },

  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <HomePage />,
  },
];

// Tech Routes
export const techRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <TechUsers />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/products",
    component: <Products />,
    showInSidebar: true,
    dropdown: true,
    dropdownItems: items,
  },

  {
    type: "collapse",
    name: "Account Opening API",
    key: "account-opening-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/account-opening-api",
    component: <AccountOpening />,
  },
  {
    type: "collapse",
    name: "Funding API",
    key: "funding-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/funding-api",
    component: <Funding />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.3",
    component: <TradingTwoFiveThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.1",
    component: <TradingTwoFiveOne />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5",
    component: <TradingTwoFive />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.4",
    component: <TradingTwoFour />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.3",
    component: <TradingTwoThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.2.4",
    component: <Trading />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.5",
    component: <FixThreeFive />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.2",
    component: <Fix />,
  },
  {
    type: "collapse",
    name: "Journal API",
    key: "journal-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/journal-api",
    component: <JournalAPI />,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <HomePage />,
  },
];

// Admin Routes
export const adminRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <Users />,
    showInSidebar: true,
  },
  // {
  //   type: "collapse",
  //   name: "Sandbox Requests",
  //   key: "sandbox-requests",
  //   icon: <Icon fontSize="small">add_chart</Icon>,
  //   route: "/sandbox-requests",
  //   component: <AccessRequests />,
  //   showInSidebar: true,
  // },

  {
    type: "collapse",
    name: "Production Requests",
    key: "production-requests",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/production-requests",
    component: <ProductionRequest />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Tech Requests",
    key: "tech-requests",
    icon: <Icon fontSize="small">add_chart</Icon>,
    route: "/tech-requests",
    component: <TechUsers />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Support",
    key: "support",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/support",
    component: <SupportRM />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/products",
    component: <Products />,
    showInSidebar: true,
    dropdown: true,
    dropdownItems: items,
  },

  {
    type: "collapse",
    name: "Account Opening API",
    key: "account-opening-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/account-opening-api",
    component: <AccountOpening />,
  },
  {
    type: "collapse",
    name: "Funding API",
    key: "funding-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/funding-api",
    component: <Funding />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.3",
    component: <TradingTwoFiveThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5.1",
    component: <TradingTwoFiveOne />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.5",
    component: <TradingTwoFive />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.4",
    component: <TradingTwoFour />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.3",
    component: <TradingTwoThree />,
  },
  {
    type: "collapse",
    name: "Trading API",
    key: "trading-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/trading-api-v2.2.4",
    component: <Trading />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.5",
    component: <FixThreeFive />,
  },
  {
    type: "collapse",
    name: "FIX Specifications",
    key: "fix-specifications",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/fix-specifications-v3.2",
    component: <Fix />,
  },
  {
    type: "collapse",
    name: "Journal API",
    key: "journal-api",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/products/journal-api",
    component: <JournalAPI />,
  },
  {
    type: "collapse",
    name: "Audit Trail",
    key: "audit-trail",
    icon: <Icon fontSize="small">find_in_page </Icon>,
    route: "/audit-trail",
    component: <AuditTrail />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <HomePage />,
  },
];

// Unaunthenticated Routes
export const unauthenticatedRoutes = [
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign In Admin",
    key: "sign-in-admin",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/admin",
    component: <SignInAdmin />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "Success",
    key: "success",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up/success",
    component: <RegisterSuccess />,
  },
  {
    type: "collapse",
    name: "NDA Success",
    key: "nda-success",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up/nda/success",
    component: <NDASuccess />,
  },
  {
    type: "collapse",
    name: "Forget Password",
    key: "forget-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/forgot-password",
    component: <ForgetPassword />,
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/reset-password",
    component: <ResetPassword />,
  },
];
